<template>
  <div class="wrapper" :class="[{ 'nav-open': $sidebar.showSidebar },{ rtl: $route.meta.rtlActive }]">
    <notifications></notifications>
    <side-bar :title="$store.getters.config.company">
      <template slot="links">
        <sidebar-item id="/dashboard"
            :link="{ name: $t('pages.Dashboard'), icon: 'dashboard', path: '/dashboard' }"
        ></sidebar-item>
        <sidebar-item id="/sms" :link="{ name: $t('pages.sms'), icon: 'sms' }">
          <sidebar-item id="/sms/templates"
              :link="{ name: $t('pages.sms_templates'), path: '/sms/templates' }"
          ></sidebar-item>
          <sidebar-item id="/sms/detail"
              :link="{ name: $t('pages.sms_detail'), path: '/sms/detail' }"
          ></sidebar-item>
          <sidebar-item id="/sms/group"
              :link="{ name: $t('pages.sms_group'), path: '/sms/group' }"
          ></sidebar-item>
          <sidebar-item id="/sms/tarification/partners"
              :link="{ name: $t('pages.sms_tarification_partners'), path: '/sms/tarification/partners' }"
          ></sidebar-item>
          <sidebar-item id="/sms/tarification/service_providers"
              :link="{ name: $t('pages.sms_tarification_operators'), path: '/sms/tarification/service_providers' }"
          ></sidebar-item>
          <sidebar-item id="/sms/priority_rules"
              :link="{ name: $t('pages.sms_priority_rules'), path: '/sms/priority_rules' }"
          ></sidebar-item>
          <sidebar-item id="/sms/originator_rules"
              :link="{ name: $t('pages.sms_originator_rules'), path: '/sms/originator_rules' }"
          ></sidebar-item>
          <sidebar-item id="/sms/filters"
              :link="{ name: $t('pages.sms_filters'), path: '/sms/filters' }"
          ></sidebar-item>
          <sidebar-item id="/sms/restrictions"
                        :link="{ name: $t('pages.originator_restrictions'), path: '/sms/restrictions' }"
          ></sidebar-item>
          <sidebar-item id="/sms/incoming_tariffs"
              :link="{ name: $t('pages.sms_incoming_tariffs'), path: '/sms/incoming_tariffs' }"
          ></sidebar-item>
          <sidebar-item id="/sms/detail_incoming"
              :link="{ name: $t('pages.sms_detail_incoming'), path: '/sms/detail_incoming' }"
          ></sidebar-item>
          <sidebar-item id="/sms/group_incoming"
              :link="{ name: $t('pages.sms_group_incoming'), path: '/sms/group_incoming' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item id="/call" :link="{ name: $t('pages.call'), icon: 'call' }">
          <sidebar-item id="/call/detail"
              :link="{ name: $t('pages.call_detail'), path: '/call/detail' }"
          ></sidebar-item>
          <sidebar-item id="/call/group"
              :link="{ name: $t('pages.call_group'), path: '/call/group' }"
          ></sidebar-item>
          <sidebar-item id="/call/detail_incoming"
              :link="{ name: $t('pages.call_detail_incoming'), path: '/call/detail_incoming' }"
          ></sidebar-item>
          <sidebar-item id="/call/group_incoming"
              :link="{ name: $t('pages.call_group_incoming'), path: '/call/group_incoming' }"
          ></sidebar-item>
          <sidebar-item id="/call/originator_rules"
              :link="{ name: $t('pages.call_originator_rules'), path: '/call/originator_rules' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item id="/email" :link="{ name: $t('pages.email'), icon: 'email' }">
          <sidebar-item id="/email/templates"
              :link="{ name: $t('pages.email_templates'), path: '/email/templates' }"
          ></sidebar-item>
          <sidebar-item id="/email/detail"
              :link="{ name: $t('pages.email_detail'), path: '/email/detail' }"
          ></sidebar-item>
          <sidebar-item id="/email/group"
              :link="{ name: $t('pages.email_group'), path: '/email/group' }"
          ></sidebar-item>
          <sidebar-item id="/email/partners/tariffs"
              :link="{ name: $t('pages.email_clients_tariff'), path: '/email/partners/tariffs' }"
          ></sidebar-item>
          <sidebar-item id="/email/service_providers/tariffs"
              :link="{ name: $t('pages.email_provider_tariff'), path: '/email/service_providers/tariffs' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item id="/push" :link="{ name: $t('pages.push'), icon: 'notifications' }">
          <sidebar-item id="/push/templates"
              :link="{ name: $t('pages.push_templates'), path: '/push/templates' }"
          ></sidebar-item>
          <sidebar-item id="/push/detail"
              :link="{ name: $t('pages.push_detail'), path: '/push/detail' }"
          ></sidebar-item>
          <sidebar-item id="/push/group"
              :link="{ name: $t('pages.push_group'), path: '/push/group' }"
          ></sidebar-item>
          <sidebar-item id="/push/applications/attributes"
              :link="{ name: $t('pages.attributes'), path: '/push/applications/attributes' }"
          ></sidebar-item>
          <sidebar-item id="/push/applications"
              :link="{ name: $t('pages.push_applications'), path: '/push/applications' }"
          ></sidebar-item>
          <sidebar-item id="/push/groups_applications"
              :link="{ name: $t('pages.push_groups_applications'), path: '/push/groups_applications' }"
          ></sidebar-item>
          <sidebar-item id="/push/subscribers"
              :link="{ name: $t('pages.push_subscribers'), path: '/push/subscribers' }"
          ></sidebar-item>
          <sidebar-item id="/push/history"
              :link="{ name: $t('pages.push_history'), path: '/push/history' }"
          ></sidebar-item>
          <sidebar-item id="/push/partners/tariffs"
              :link="{ name: $t('pages.push_client_tariff'), path: '/push/partners/tariffs' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item id="/viber" :link="{ name: $t('pages.viber'), icon: 'forum' }">
          <sidebar-item id="/viber/templates"
              :link="{ name: $t('pages.viber_templates'), path: '/viber/templates' }"
          ></sidebar-item>
          <sidebar-item id="/viber/detail"
              :link="{ name: $t('pages.viber_detail'), path: '/viber/detail' }"
          ></sidebar-item>
          <sidebar-item id="/viber/group"
              :link="{ name: $t('pages.viber_group'), path: '/viber/group' }"
          ></sidebar-item>
          <sidebar-item id="/viber/partners/tariffs"
              :link="{ name: $t('pages.viber_client_tariff'), path: '/viber/partners/tariffs' }"
          ></sidebar-item>
          <sidebar-item id="/viber/service_providers/tariffs"
              :link="{ name: $t('pages.viber_provider_tariff'), path: '/viber/service_providers/tariffs' }"
          ></sidebar-item>
          <sidebar-item id="/viber/incoming_tariffs"
                        :link="{ name: $t('pages.viber_incoming_tariffs'), path: '/viber/incoming_tariffs' }"
          ></sidebar-item>
          <sidebar-item id="/viber/detail_incoming"
                        :link="{ name: $t('pages.viber_detail_incoming'), path: '/viber/detail_incoming' }"
          ></sidebar-item>
          <sidebar-item id="/viber/group_incoming"
                        :link="{ name: $t('pages.viber_group_incoming'), path: '/viber/group_incoming' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item id="/whatsapp" :link="{ name: $t('pages.whatsapp'), icon: 'whatsapp' }">
          <sidebar-item id="/whatsapp/templates"
              :link="{ name: $t('pages.whatsapp_templates'), path: '/whatsapp/templates' }"
          ></sidebar-item>
          <sidebar-item id="/whatsapp/detail"
              :link="{ name: $t('pages.whatsapp_detail'), path: '/whatsapp/detail' }"
          ></sidebar-item>
          <sidebar-item id="/whatsapp/group"
              :link="{ name: $t('pages.whatsapp_group'), path: '/whatsapp/group' }"
          ></sidebar-item>
          <sidebar-item id="/whatsapp/partners/tariffs"
              :link="{ name: $t('pages.whatsapp_client_tariff'), path: '/whatsapp/partners/tariffs' }"
          ></sidebar-item>
          <sidebar-item id="/whatsapp/service_providers/tariffs"
              :link="{ name: $t('pages.whatsapp_provider_tariff'), path: '/whatsapp/service_providers/tariffs' }"
          ></sidebar-item>
          <sidebar-item id="/whatsapp/incoming_tariffs"
                        :link="{ name: $t('pages.incoming_tariffs'), path: '/whatsapp/incoming_tariffs' }"
          ></sidebar-item>
          <sidebar-item id="/whatsapp/detail_incoming"
              :link="{ name: $t('pages.whatsapp_detail_incoming'), path: '/whatsapp/detail_incoming' }"
          ></sidebar-item>
          <sidebar-item id="/whatsapp/group_incoming"
                        :link="{ name: $t('pages.whatsapp_group_incoming'), path: '/whatsapp/group_incoming' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item id="/mail_notify" :link="{ name: $t('pages.mail_notify'), icon: 'vk' }" class="vk-icon">
          <sidebar-item id="/mail_notify/templates"
                        :link="{ name: $t('pages.mail_notify_templates'), path: '/mail_notify/templates' }"
          ></sidebar-item>
          <sidebar-item id="/mail_notify/management_templates"
                        :link="{ name: $t('pages.mail_notify_management_templates'), path: '/mail_notify/management_templates' }"
          ></sidebar-item>
          <sidebar-item id="/mail_notify/detail"
                        :link="{ name: $t('pages.mail_notify_detail'), path: '/mail_notify/detail' }"
          ></sidebar-item>
          <sidebar-item id="/mail_notify/group"
                        :link="{ name: $t('pages.mail_notify_group'), path: '/mail_notify/group' }"
          ></sidebar-item>
          <sidebar-item id="/mail_notify/management_services"
                        :link="{ name: $t('pages.mail_notify_management_services'), path: '/mail_notify/management_services' }"
          ></sidebar-item>
          <sidebar-item id="/mail_notify/partners/tariffs"
                        :link="{ name: $t('pages.mail_notify_client_tariff'), path: '/mail_notify/partners/tariffs' }"
          ></sidebar-item>
          <sidebar-item id="/mail_notify/service_providers/tariffs"
                        :link="{ name: $t('pages.mail_notify_provider_tariff'), path: '/mail_notify/service_providers/tariffs' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item id="/custom" :link="{ name: $t('pages.custom'), icon: 'inbox' }">
          <sidebar-item id="/custom/templates"
                        :link="{ name: $t('pages.custom_templates'), path: '/custom/templates' }"
          ></sidebar-item>
          <sidebar-item id="/custom/detail"
                        :link="{ name: $t('pages.custom_detail'), path: '/custom/detail' }"
          ></sidebar-item>
          <sidebar-item id="/custom/group"
                        :link="{ name: $t('pages.custom_group'), path: '/custom/group' }"
          ></sidebar-item>
          <sidebar-item id="/custom/partners/tariffs"
                        :link="{ name: $t('pages.custom_client_tariff'), path: '/custom/partners/tariffs' }"
          ></sidebar-item>
          <sidebar-item id="/custom/service_providers/tariffs"
                        :link="{ name: $t('pages.custom_provider_tariff'), path: '/custom/service_providers/tariffs' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item id="/settings" :link="{ name: $t('pages.settings'), icon: 'settings' }">
          <sidebar-item id="/settings/service_providers"
              :link="{ name: $t('pages.service_providers'), path: '/settings/service_providers' }"
          ></sidebar-item>
          <sidebar-item id="/settings/partners"
              :link="{ name: $t('pages.partners'), path: '/settings/partners' }"
          ></sidebar-item>
          <sidebar-item id="/settings/accounts"
              :link="{ name: $t('pages.accounts'), path: '/settings/accounts' }"
          ></sidebar-item>
          <sidebar-item id="/settings/originators"
              :link="{ name: $t('pages.originators'), path: '/settings/originators' }"
          ></sidebar-item>
          <sidebar-item id="/settings/system_settings"
              :link="{ name: $t('pages.system_settings'), path: '/settings/system_settings' }"
          ></sidebar-item>
          <sidebar-item id="/settings/reports"
              :link="{ name: $t('pages.reports'), path: '/settings/reports' }"
          ></sidebar-item>
          <sidebar-item id="/settings/message_types"
              :link="{ name: $t('pages.message_types'), path: '/settings/message_types' }"
          ></sidebar-item>
          <sidebar-item id="/settings/message_categories"
              :link="{ name: $t('pages.message_categories'), path: '/settings/message_categories' }"
          ></sidebar-item>
          <sidebar-item id="/settings/duplicates"
              :link="{ name: $t('pages.duplicates'), path: '/settings/duplicates' }"
          ></sidebar-item>
          <sidebar-item id="/settings/quantity_limits"
              :link="{ name: $t('pages.quantity_limits'), path: '/settings/quantity_limits' }"
          ></sidebar-item>
          <sidebar-item id="/settings/provider_connections"
              :link="{ name: $t('pages.provider_connections'), path: '/settings/provider_connections' }"
          ></sidebar-item>
          <sidebar-item id="/settings/partners_connections"
              :link="{ name: $t('pages.partners_connections'), path: '/settings/partners_connections' }"
          ></sidebar-item>
          <sidebar-item id="/settings/smpp_connections"
              :link="{ name: $t('pages.smpp_connections'), path: '/settings/smpp_connections' }"
          ></sidebar-item>
          <sidebar-item id="/settings/preprocessing_rules"
              :link="{ name: $t('pages.preprocessing_rules'), path: '/settings/preprocessing_rules' }"
          ></sidebar-item>
          <sidebar-item id="/settings/black_lists"
              :link="{ name: $t('pages.black_lists'), path: '/settings/black_lists' }"
          ></sidebar-item>
          <sidebar-item id="/settings/black_lists_generals"
              :link="{ name: $t('pages.black_list_generals'), path: '/settings/black_list/generals/recipients' }"
          ></sidebar-item>
          <sidebar-item id="/settings/template_params"
                        :link="{ name: $t('pages.template_params'), path: '/settings/template_params' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item id="/user_management" :link="{ name: $t('pages.user_management'), icon: 'supervisor_account' }">
          <sidebar-item id="/user_management/partner_users"
              :link="{ name: $t('pages.partner_users'), path: '/user_management/partner_users' }"
          ></sidebar-item>
          <sidebar-item id="/user_management/system_users"
              :link="{ name: $t('pages.system_users'), path: '/user_management/system_users' }"
          ></sidebar-item>
          <sidebar-item id="/user_management/action_users"
                        :link="{ name: $t('pages.action_users'), path: '/user_management/action_users' }"
          ></sidebar-item>
          <sidebar-item id="/user_management/partner_user_roles"
                        :link="{ name: $t('pages.partner_user_roles'), path: '/user_management/partner_user_roles' }"
          ></sidebar-item>
          <sidebar-item id="/user_management/user_roles"
              :link="{ name: $t('pages.user_roles'), path: '/user_management/user_roles' }"
          ></sidebar-item>
          <sidebar-item id="/user_management/distributions_moderation"
              :link="{ name: $t('pages.distributions_moderation'), path: '/user_management/distributions_moderation' }"
          ></sidebar-item>
          <sidebar-item id="/user_management/templates_moderation"
              :link="{ name: $t('pages.templates_moderation'), path: '/user_management/templates_moderation' }"
          ></sidebar-item>
          <sidebar-item id="/user_management/system_actions"
                        :link="{ name: $t('pages.system_actions'), path: '/user_management/system_actions' }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item id="/finance"
            :link="{ name: $t('pages.finance'), icon: 'account_balance_wallet', path: '/finance' }"
        >
          <sidebar-item id="/finance/put_balances"
              :link="{ name: $t('pages.overdrafts'), path: '/finances/overdrafts' }"
          ></sidebar-item>
          <sidebar-item id="/finance/get_balances"
              :link="{ name: $t('pages.balances'), path: '/finances/balances' }"
          ></sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <loading :active.sync="isLoading"
                 :can-cancel="true" color="steelblue"
                 :is-full-page="true"></loading>
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
  import Loading from 'vue-loading-overlay/dist/vue-loading.min';
  import 'vue-loading-overlay/dist/vue-loading.css';
  /* eslint-disable no-new */
  import PerfectScrollbar from "perfect-scrollbar";
  import "perfect-scrollbar/css/perfect-scrollbar.css";
  import {mapGetters} from "vuex";
  import TopNavbar from "./TopNavbar.vue";
  import ContentFooter from "./ContentFooter.vue";
  import MobileMenu from "./Extra/MobileMenu.vue";
  import { ZoomCenterTransition } from "vue2-transitions";

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  export default {
    components: {
      Loading,
      TopNavbar,
      ContentFooter,
      MobileMenu,
      ZoomCenterTransition
    },
    computed:{
      ...mapGetters([
        'isLoading'
      ])
    },
    data() {
      return {
        sidebarMini: true,
        sidebarImg: true
      };
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      },
      minimizeSidebar() {
        if (this.$sidebar) {
          this.$sidebar.toggleMinimize();
        }
      }
    },
    mounted() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        // initScrollbar("sidebar");
        initScrollbar("sidebar-wrapper");
        // initScrollbar("main-panel");

        docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
      if (localStorage.getItem('sidebar-mini') === 'true'){
        docClasses.remove("sidebar-mini");
      }
    },
    watch: {
      sidebarMini() {
        this.minimizeSidebar();
      }
    }
  };
</script>
<style lang="scss">
  $scaleSize: 0.95;
  @keyframes zoomIn95 {
    from {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    to {
      opacity: 1;
    }
  }
  .main-panel .zoomIn {
    animation-name: zoomIn95;
  }
  @keyframes zoomOut95 {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
  }
  .main-panel .zoomOut {
    animation-name: zoomOut95;
  }
</style>
